import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaArrowDown, FaUpload } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeMenu,
  toggleState,
} from "../../sotre/redux/features/toggleMenuSlice";
import { FaBoxesPacking, FaListUl, FaVideo } from "react-icons/fa6";
import {
  PiArticleNyTimesFill,
  PiCarBold,
  PiChartBarBold,
  PiCityBold,
  PiExportBold,
  PiInfoBold,
  PiMoneyWavyBold,
  PiShoppingCartBold,
  PiSlidersBold,
  PiTestTubeFill,
  PiTrolleySuitcaseBold,
  PiVideoBold,
  PiWalletBold,
  PiBackpack,
  PiGearBold,
} from "react-icons/pi";
import { getApi } from "../../services/api/globalApi";
import OrderedSidebarItems from "./OrderedSidebarItems";
import SidebarGroup from "./SidebarGroup";
import { useAdminAccess } from "../access/AdminAccessContext";

export default function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { canVisit } = useAdminAccess();
  const canSeeCampaigns = canVisit("/campaigns");

  const logOut = async () => {
    closeMobileMenu();
    try {
      const path = "api/auth/logout";
      await getApi({ path });
      localStorage.removeItem("liResponse");
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const dispatch = useDispatch();

  const showMenu = useSelector(toggleState);

  const closeMobileMenu = () => {
    if (!window.matchMedia("(min-width: 1024px)").matches) {
      dispatch(closeMenu());
    }
  };

  const handleMenuNavigation = (event) => {
    // Delegation covers every Link/NavLink, including query-only and current routes.
    if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.target.closest("a[href]")) {
      closeMobileMenu();
    }
  };

  const [sideBarToggle, setSideBarToggle] = useState({
    settings: location.pathname.startsWith("/settings/"),
    subMenu1: false,
    subMenu2: false,
    subMenu3: false,
    subMenu4: location.pathname === "/product-discounts",
    subMenu5: false,
    subMenu6: false,
    subMenu7: location.pathname.startsWith("/reports/"),
    subMenu8: false,
    subMenu9: false,
    subMenu10: false,
    subMenu11: false,
    subMenu12: false,
    subMenu13: false,
    subMenu14: false,
    subMenu15: false,
    subMenu16: false,
    subMenu17: false,
    subMenu18: false,
    subMenu19: false,
    subMenu20: false,
    subMenu21: false,
    subMenu22: false,
    subMenu23: false,
    subMenu24: false,
    subMenu25: false,
    subMenu26: false,
    subMenu27: false,
    subMenu28: false,
    subMenu29: location.pathname === "/campaigns",
  });
  const [campaignMenu, setCampaignMenu] = useState([]);

  useEffect(() => {
    if (location.pathname.startsWith("/settings/")) {
      setSideBarToggle((current) => ({ ...current, settings: true }));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!canSeeCampaigns) { setCampaignMenu([]); return undefined; }
    const refreshCampaignMenu = () => {
      getApi({ path: "admin/campaigns" })
        .then((response) => setCampaignMenu(response?.data?.result?.campaigns || []))
        .catch(() => setCampaignMenu([]));
    };
    refreshCampaignMenu();
    window.addEventListener("campaigns-updated", refreshCampaignMenu);
    return () => window.removeEventListener("campaigns-updated", refreshCampaignMenu);
  }, [location.pathname, canSeeCampaigns]);

  return (
    <>
      <div
        onClick={() => dispatch(closeMenu())}
        className={`lg:hidden z-[26] w-full h-full fixed top-0 right-0 bg-black/30 ${
          showMenu ? "block" : "hidden"
        }`}
      ></div>
      <div
        className={`admin-sidebar w-full h-full fixed bottom-0 right-0 z-[27] lg:z-20 lg:relative lg:w-[272px] lg:shrink-0 bg-white dark:bg-slate-900 rounded-2xl transition-[bottom] duration-300 ${
          !showMenu && "bottom-[-100%]"
        } lg:bottom-0`}
      >
        <div className="admin-sidebar-brand flex flex-col items-center justify-between gap-2 px-6 pt-5">
          <img
            className="w-24 lg:w-28 mx-auto"
            src={require("./../../assets/image/logo.png")}
            alt="Logo"
          />
          <FaArrowDown
            onClick={() => dispatch(closeMenu())}
            size={38}
            className="text-red-700 lg:hidden p-1 bg-white dark:bg-gray-800 rounded-md transition-all cursor-pointer hover:scale-110"
          />
        </div>
        <div className="flex w-full p-4" onClick={handleMenuNavigation}>
          <OrderedSidebarItems>
            <li key="dashboard" data-sidebar-id="dashboard" className="my-px lg:w-full">
              <NavLink
                to="/"
                className={`${
                  ["/"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <svg
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                  </svg>
                </span>
                <span className="mx-3">داشبورد</span>
                {/* <span className="flex items-center justify-center text-sm text-gray-500 font-semibold bg-gray-300 h-6 px-2 rounded-full ml-auto">3</span> */}
              </NavLink>
            </li>
            <li className="my-px lg:w-full">
              <span className="flex font-medium text-sm text-gray-400 px-4 my-4 uppercase">
                ابزار ها
              </span>
            </li>

            <SidebarGroup key="users" data-sidebar-id="users"
              open={sideBarToggle.subMenu1}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu1: !sideBarToggle.subMenu1,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <svg
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                  </svg>
                </span>
                <span className="mx-3">کاربران</span>
              </h3>

              <NavLink
                to="/add-user"
                className={`${
                  ["/add-user"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن کاربر</span>
              </NavLink>

              <NavLink
                to="/user-list"
                className={`${
                  ["/user-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست کاربران</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="reports" data-sidebar-id="reports"
              open={sideBarToggle.subMenu7}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu7: !sideBarToggle.subMenu7,
                  })
                }
                className="flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700"
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiChartBarBold size={22} />
                </span>
                <span className="mx-3">گزارشات</span>
              </h3>

              <NavLink
                to="/reports/products"
                className={`${
                  ["/reports/products"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">محصولات</span>
              </NavLink>

              <NavLink
                to="/reports/product-stocks"
                className={`${
                  ["/reports/product-stocks", "/product-stocks-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">موجودی محصولات</span>
              </NavLink>

              <NavLink
                to="/reports/orders"
                className={`${
                  ["/reports/orders"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">سفارشات</span>
              </NavLink>
              <NavLink
                to="/reports/product-sales-summary"
                className={`${
                  ["/reports/product-sales-summary"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">خلاصه فروش کالاها</span>
              </NavLink>
              <NavLink
                to="/reports/order-statistics"
                className={`${
                  ["/reports/order-statistics"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">آمار تعداد سفارش‌ها</span>
              </NavLink>
              <NavLink
                to="/reports/all-orders"
                className={`${
                  ["/reports/all-orders"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">تمام سفارشات</span>
              </NavLink>
              <NavLink
                to="/reports/monthly-order-cohort"
                className={`${
                  ["/reports/monthly-order-cohort"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">سفارش کاربران در ماه</span>
              </NavLink>
              <NavLink
                to="/reports/users"
                className={`${
                  ["/reports/users"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">کاربران</span>
              </NavLink>
              <NavLink
                to="/reports/customers-sales"
                className={`${
                  ["/reports/customers-sales"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">خرید مشتری ها</span>
              </NavLink>
              <NavLink
                to="/reports/provinces-sales"
                className={`${
                  ["/reports/provinces-sales"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">خرید استان ها</span>
              </NavLink>
              <NavLink
                to="/reports/userCourseEnrollments"
                className={`${
                  ["/reports/userCourseEnrollments"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">خریداران دوره</span>
              </NavLink>
              <NavLink
                to="/reports/courseEnrollments"
                className={`${
                  ["/reports/courseEnrollments"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست تراکنش های دوره</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="categories" data-sidebar-id="categories"
              open={sideBarToggle.subMenu2}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu2: !sideBarToggle.subMenu2,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <FaListUl size={22} />
                </span>
                <span className="mx-3">دسته بندی</span>
              </h3>

              <NavLink
                to="/add-category"
                className={`${
                  ["/add-category"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن دسته بندی</span>
              </NavLink>

              <NavLink
                to="/category-list"
                className={`${
                  ["/category-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست دسته بندی ها</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="vendor-categories" data-sidebar-id="vendor-categories"
              open={sideBarToggle.subMenu18}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu18: !sideBarToggle.subMenu18,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <FaListUl size={22} />
                </span>
                <span className="mx-3">دسته بندی غرفه</span>
              </h3>

              <NavLink
                to="/add-vendor-store-category"
                className={`${
                  ["/add-vendor-store-category"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن دسته بندی غرفه</span>
              </NavLink>

              <NavLink
                to="/vendor-store-category-list"
                className={`${
                  ["/vendor-store-category-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست دسته بندی های غرفه</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="vendors" data-sidebar-id="vendors"
              open={sideBarToggle.subMenu19}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu19: !sideBarToggle.subMenu19,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiTrolleySuitcaseBold size={22} />
                </span>
                <span className="mx-3">غرفه ها</span>
              </h3>

              <NavLink
                to="/add-vendor-store"
                className={`${
                  ["/add-learn-category"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن غرفه</span>
              </NavLink>

              <NavLink
                to="/vendor-stores-list"
                className={`${
                  ["/learn-category-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست غرفه ها</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="learn-categories" data-sidebar-id="learn-categories"
              open={sideBarToggle.subMenu12}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu12: !sideBarToggle.subMenu12,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <FaListUl size={22} />
                </span>
                <span className="mx-3">دسته بندی آموزش ها</span>
              </h3>

              <NavLink
                to="/add-learn-category"
                className={`${
                  ["/add-learn-category"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن دسته بندی آموزش ها</span>
              </NavLink>

              <NavLink
                to="/learn-category-list"
                className={`${
                  ["/learn-category-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست دسته بندی آموزش ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="learns" data-sidebar-id="learns"
              open={sideBarToggle.subMenu13}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu13: !sideBarToggle.subMenu13,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <FaVideo size={22} />
                </span>
                <span className="mx-3">آموزش ها</span>
              </h3>

              <NavLink
                to="/add-learn"
                className={`${
                  ["/add-learn"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن آموزش</span>
              </NavLink>

              <NavLink
                to="/learn-list"
                className={`${
                  ["/learn-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست آموزش ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="products" data-sidebar-id="products"
              open={sideBarToggle.subMenu4}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu4: !sideBarToggle.subMenu4,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <FaBoxesPacking size={22} />
                </span>
                <span className="mx-3">محصولات</span>
              </h3>

              <NavLink
                to="/add-product"
                className={`${
                  ["/add-product"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن محصول</span>
              </NavLink>

              <NavLink
                to="/product-list"
                className={`${
                  ["/product-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست محصول ها</span>
              </NavLink>
              <NavLink to="/product-discounts" className={({ isActive }) => `flex min-h-12 items-center rounded-lg px-4 py-3 ${isActive ? "bg-gray-100 text-gray-600" : "text-gray-500 hover:bg-gray-200"}`}>
                <span className="mx-3">مدیریت تخفیف با اکسل</span>
              </NavLink>
              <NavLink
                to="/update-product-stock-list"
                className={`${
                  ["/update-product-stock-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">آپدیت موجودی محصولات</span>
              </NavLink>
              <NavLink
                to="/product-price-import"
                className={`${
                  ["/product-price-import"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">آپدیت قیمت با اکسل</span>
              </NavLink>

              <NavLink
                to="/update-product-stock-report"
                className={`${
                  ["/update-product-stock-report"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لاگ آپدیت موجودی محصول</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="courses" data-sidebar-id="courses"
              open={sideBarToggle.subMenu21}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu21: !sideBarToggle.subMenu21,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiVideoBold size={22} />
                </span>
                <span className="mx-3">دوره ها</span>
              </h3>

              <NavLink
                to="/add-course"
                className={`${
                  ["/add-course"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن دوره</span>
              </NavLink>

              <NavLink
                to="/course-list"
                className={`${
                  ["/course-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست دوره ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="vendor-products" data-sidebar-id="vendor-products"
              open={sideBarToggle.subMenu20}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu20: !sideBarToggle.subMenu20,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <FaBoxesPacking size={22} />
                </span>
                <span className="mx-3">محصولات غرفه</span>
              </h3>

              <NavLink
                to="/vendor-product-list"
                className={`${
                  ["/vendor-product-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست محصولات غرفه</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="orders" data-sidebar-id="orders"
              open={sideBarToggle.subMenu10}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu10: !sideBarToggle.subMenu10,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiShoppingCartBold size={22} />
                </span>
                <span className="mx-3">سفارشات</span>
              </h3>
              <NavLink
                to="/order-list"
                className={`${
                  ["/order-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">مدیریت سفارشات</span>
              </NavLink>
              <NavLink
                to="/barcodes-upload"
                className={`${
                  ["/barcodes-upload"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">آپلود بارکد</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="shipping" data-sidebar-id="shipping"
              open={sideBarToggle.subMenu8}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu8: !sideBarToggle.subMenu8,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiCarBold size={22} />
                </span>
                <span className="mx-3">حمل و نقل</span>
              </h3>

              <NavLink
                to="/add-product-shipping"
                className={`${
                  ["/add-product-shipping"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن حمل و نقل</span>
              </NavLink>

              <NavLink
                to="/product-shipping-list"
                className={`${
                  ["/product-shipping-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست حمل و نقل ها</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="faq" data-sidebar-id="faq"
              open={sideBarToggle.subMenu22}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu22: !sideBarToggle.subMenu22,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiInfoBold size={22} />
                </span>
                <span className="mx-3">سوالات متداول</span>
              </h3>

              <NavLink
                to="/add-faq"
                className={`${
                  ["/add-faq"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن سوال</span>
              </NavLink>

              <NavLink
                to="/faq-list"
                className={`${
                  ["/faq-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست سوالات</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="discounts" data-sidebar-id="discounts"
              open={sideBarToggle.subMenu9}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu9: !sideBarToggle.subMenu9,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiMoneyWavyBold size={22} />
                </span>
                <span className="mx-3">تخفیفات</span>
              </h3>

              <NavLink
                to="/discount-manage"
                className={`${
                  ["/discount-manage"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">مدیریت تخفیف</span>
              </NavLink>
            </SidebarGroup>

            <SidebarGroup key="campaigns" data-sidebar-id="campaigns"
              open={sideBarToggle.subMenu29}
            >
              <h3
                onClick={() => setSideBarToggle((current) => ({ ...current, subMenu29: !current.subMenu29 }))}
                className="flex h-12 cursor-pointer flex-row items-center rounded-lg bg-gray-100 px-4 text-gray-600 hover:bg-gray-200 dark:hover:bg-gray-700"
              >
                <PiMoneyWavyBold size={22} />
                <span className="mx-3">کمپین‌ها</span>
              </h3>
              <Link to="/campaigns" aria-current={location.pathname === "/campaigns" && !new URLSearchParams(location.search).has("campaign") ? "page" : undefined}
                className="flex items-center rounded-lg px-4 text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700">
                <span className="mx-3">مدیریت کمپین‌ها</span>
              </Link>
              {campaignMenu.map((campaign) => (
                <Link key={campaign.id} to={`/campaigns?campaign=${encodeURIComponent(campaign.id)}`}
                  aria-current={location.pathname === "/campaigns" && new URLSearchParams(location.search).get("campaign") === String(campaign.id) ? "page" : undefined}
                  title={campaign.name}
                  className="flex items-center rounded-lg px-4 text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700">
                  <span className="mx-3 truncate">{campaign.name}</span>
                </Link>
              ))}
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="coupons" data-sidebar-id="coupons"
              open={sideBarToggle.subMenu11}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu11: !sideBarToggle.subMenu11,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiMoneyWavyBold size={22} />
                </span>
                <span className="mx-3">کوپن ها</span>
              </h3>
              <NavLink
                to="/add-coupon"
                className={`${
                  ["/add-coupon"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن کوپن</span>
              </NavLink>

              <NavLink
                to="/coupon-list"
                className={`${
                  ["/coupon-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست کوپن ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="wallets" data-sidebar-id="wallets"
              open={sideBarToggle.subMenu14}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu14: !sideBarToggle.subMenu14,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiWalletBold size={22} />
                </span>
                <span className="mx-3">کیف پول</span>
              </h3>

              <NavLink
                to="/add-deposit"
                className={`${
                  ["/add-deposit"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">ایجاد تراکنش</span>
              </NavLink>

              <NavLink
                to="/wallets-transaction"
                className={`${
                  ["/wallets-transaction"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست تراکنش ها</span>
              </NavLink>
              <NavLink
                to="/wallets/bulk-deposit"
                className={`${
                  ["/wallets/bulk-deposit"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">شارژ گروهی کیف پول</span>
              </NavLink>
              <NavLink to="/wallets/bulk-history" className={({ isActive }) => `flex flex-row items-center h-12 px-4 rounded-lg ${isActive ? "text-gray-600 bg-gray-100" : "text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"}`}>
                <span className="mx-3">سوابق واریز گروهی</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="course-enrollments" data-sidebar-id="course-enrollments"
              open={sideBarToggle.subMenu24}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu24: !sideBarToggle.subMenu24,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiWalletBold size={22} />
                </span>
                <span className="mx-3">مدیریت خرید دوره</span>
              </h3>
              <NavLink
                to="/courseenrollment-list"
                className={`${
                  ["/courseenrollment-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست تراکنش ها</span>
              </NavLink>
              <NavLink
                to="/courseenrollment-register-multiple"
                className={`${
                  ["/courseenrollment-register-multiple"].includes(
                    location.pathname
                  )
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">ثبت نام کاربران</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="affiliate-enrollments" data-sidebar-id="affiliate-enrollments"
              open={sideBarToggle.subMenu28}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu28: !sideBarToggle.subMenu28,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiWalletBold size={22} />
                </span>
                <span className="mx-3">تراکنش ثبت نمایندگی</span>
              </h3>
              <NavLink
                to="/affiliateEnrollments-list"
                className={`${
                  ["/affiliateEnrollments-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست تراکنش ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="articles" data-sidebar-id="articles"
              open={sideBarToggle.subMenu6}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu6: !sideBarToggle.subMenu6,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiArticleNyTimesFill size={22} />
                </span>
                <span className="mx-3">مقالات</span>
              </h3>

              <NavLink
                to="/add-article"
                className={`${
                  ["/add-article"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن مقاله</span>
              </NavLink>

              <NavLink
                to="/article-list"
                className={`${
                  ["/article-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست مقاله ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="sliders" data-sidebar-id="sliders"
              open={sideBarToggle.subMenu16}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu16: !sideBarToggle.subMenu16,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiSlidersBold size={22} />
                </span>
                <span className="mx-3">اسلایدر</span>
              </h3>

              <NavLink
                to="/add-slider"
                className={`${
                  ["/add-slider"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">افزودن اسلایدر</span>
              </NavLink>
              <NavLink
                to="/slider-list"
                className={`${
                  ["/slider-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست اسلایدر ها</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="provinces" data-sidebar-id="provinces"
              open={sideBarToggle.subMenu17}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu17: !sideBarToggle.subMenu17,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiCityBold size={22} />
                </span>
                <span className="mx-3">استان و شهر</span>
              </h3>

              <NavLink
                to="/province-list"
                className={`${
                  ["/province-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">مدیریت استان و شهر</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="public-fields" data-sidebar-id="public-fields"
              open={sideBarToggle.subMenu23}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu23: !sideBarToggle.subMenu23,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiTestTubeFill size={22} />
                </span>
                <span className="mx-3"> قسمت های سایت</span>
              </h3>

              <NavLink
                to="/public-field-manage"
                className={`${
                  ["/public-field-manage"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">مدیریت بخش ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>
            <SidebarGroup key="files" data-sidebar-id="files"
              open={sideBarToggle.subMenu5}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu5: !sideBarToggle.subMenu5,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <FaUpload size={22} />
                </span>
                <span className="mx-3">فایل ها</span>
              </h3>

              <NavLink
                to="/file"
                className={`${
                  ["/file"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">آپلود فایل</span>
              </NavLink>

              <NavLink
                to="/file-list"
                className={`${
                  ["/file-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست فایل ها</span>
              </NavLink>
              <NavLink
                to="/file-list/vendors"
                className={`${
                  ["/file-list/vendors"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">لیست فایل های غرفه ها</span>
              </NavLink>
            </SidebarGroup>
            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>

            <SidebarGroup key="backups" data-sidebar-id="backups"
              open={sideBarToggle.subMenu25}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu25: !sideBarToggle.subMenu25,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiBackpack size={22} />
                </span>
                <span className="mx-3">بک آپ</span>
              </h3>

              <NavLink
                to="/backup-list"
                className={`${
                  ["/backup-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">مدیریت بک آپ</span>
              </NavLink>
            </SidebarGroup>

            <SidebarGroup key="exports" data-sidebar-id="exports"
              open={sideBarToggle.subMenu15}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu15: !sideBarToggle.subMenu15,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg text-gray-500">
                  <PiExportBold size={22} />
                </span>
                <span className="mx-3">خروجی دیتا</span>
              </h3>

              <NavLink
                to="/export"
                className={`${
                  ["/export"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                <span className="mx-3">خروجی دیتا</span>
              </NavLink>
            </SidebarGroup>

            <span className="md:hidden w-full h-[1px] bg-gray-200 rounded-xl my-1"></span>

            <SidebarGroup
              key="settings"
              data-sidebar-id="settings"
              open={sideBarToggle.settings} submenuId="sidebar-settings-submenu"
            >
              <button
                type="button"
                aria-expanded={sideBarToggle.settings}
                aria-controls="sidebar-settings-submenu"
                onClick={() => setSideBarToggle((current) => ({ ...current, settings: !current.settings }))}
                className="flex h-12 w-full items-center rounded-lg bg-gray-100 px-4 text-gray-600 hover:bg-gray-200 dark:hover:bg-gray-700"
              >
                <span className="flex items-center justify-center text-lg text-gray-500"><PiGearBold size={22} /></span>
                <span className="mx-3">تنظیمات</span>
              </button>
                <NavLink
                  to="/settings/maintenance"
                  className={({ isActive }) => `flex min-h-12 items-center rounded-lg px-4 py-3 ${isActive ? "bg-gray-100 text-gray-600" : "text-gray-500 hover:bg-gray-200"}`}
                >
                  <span className="mx-3">حالت نگهداری سایت</span>
                </NavLink>
                <NavLink
                  to="/settings/access"
                  className={({ isActive }) => `flex min-h-12 items-center rounded-lg px-4 py-3 ${isActive ? "bg-gray-100 text-gray-600" : "text-gray-500 hover:bg-gray-200"}`}
                >
                  <span className="mx-3">تنظیمات سطح دسترسی‌ها</span>
                </NavLink>
                <NavLink
                  to="/settings/order-appearance"
                  className={({ isActive }) => `flex min-h-12 items-center rounded-lg px-4 py-3 ${isActive ? "bg-gray-100 text-gray-600" : "text-gray-500 hover:bg-gray-200"}`}
                >
                  <span className="mx-3">صفحه ثبت نهایی سفارش و فاکتور</span>
                </NavLink>
                <NavLink
                  to="/settings/sidebar"
                  className={({ isActive }) => `flex h-12 items-center rounded-lg px-4 ${isActive ? "bg-gray-100 text-gray-600" : "text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"}`}
                >
                  <span className="mx-3">تنظیمات سایدبار</span>
                </NavLink>
                <NavLink
                  to="/settings/updates"
                  className={({ isActive }) => `flex h-12 items-center rounded-lg px-4 ${isActive ? "bg-gray-100 text-gray-600" : "text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700"}`}
                >
                  <span className="mx-3">وضعیت بروزرسانی</span>
                </NavLink>
            </SidebarGroup>

            <li className="my-px cursor-pointer" onClick={logOut}>
              <p className="flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 hover:bg-gray-200 dark:hover:bg-gray-700">
                <span className="flex items-center justify-center text-lg text-red-400">
                  <svg
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"></path>
                  </svg>
                </span>
                <span className="mx-3">خروج</span>
              </p>
            </li>
          </OrderedSidebarItems>
        </div>
      </div>
    </>
  );
}
